import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, renderSlot as _renderSlot, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "contact-popup__text-section popup-contact-section" }
const _hoisted_2 = { class: "contact-popup__text-section-title mb-32" }
const _hoisted_3 = { class: "contact-popup__text-section-description mb-42" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "divider mb-42" }, null, -1)
const _hoisted_5 = ["href"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "contact-popup__text-section-social-links" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = ["href", "innerHTML"]
const _hoisted_10 = { key: 1 }
const _hoisted_11 = ["href", "innerHTML"]
const _hoisted_12 = { key: 2 }
const _hoisted_13 = ["href", "innerHTML"]
const _hoisted_14 = { class: "contact-popup__form-section popup-form-section" }
const _hoisted_15 = { class: "contact-popup__form-section-title" }
const _hoisted_16 = { class: "contact-form__checkbox-wrapper" }
const _hoisted_17 = ["href", "target"]
const _hoisted_18 = {
  ref: "submitButton",
  class: "contact-form__button segmented-button segmented-button--full segmented-button--green"
}
const _hoisted_19 = { class: "segmented-button__label" }
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = ["src"]
const _hoisted_22 = { class: "contact-popup__successful-submission-title mb-32" }
const _hoisted_23 = { class: "contact-popup__successful-submission-description mb-42" }
const _hoisted_24 = { class: "segmented-button__label" }
const _hoisted_25 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormKit = _resolveComponent("FormKit")!
  const _component_popup = _resolveComponent("popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_popup, {
      ref: "popup",
      class: "contact-popup"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("h4", _hoisted_2, _toDisplayString(_ctx.$t("heuver-albourgh.components.contactPopup.title")), 1),
          _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t("heuver-albourgh.components.contactPopup.description")), 1),
          _hoisted_4,
          _createElementVNode("a", {
            href: 'mailto:' + _ctx.contactEmailAddress,
            class: "email mb-42"
          }, [
            _createElementVNode("div", { innerHTML: _ctx.EmailIcon }, null, 8, _hoisted_6),
            _createTextVNode(" " + _toDisplayString(_ctx.contactEmailAddress), 1)
          ], 8, _hoisted_5),
          _createElementVNode("ul", _hoisted_7, [
            (_ctx.instagramHandle)
              ? (_openBlock(), _createElementBlock("li", _hoisted_8, [
                  _createElementVNode("a", {
                    href: _ctx.instagramHandle,
                    target: "_blank",
                    innerHTML: _ctx.InstagramIcon
                  }, null, 8, _hoisted_9)
                ]))
              : _createCommentVNode("", true),
            (_ctx.facebookHandle)
              ? (_openBlock(), _createElementBlock("li", _hoisted_10, [
                  _createElementVNode("a", {
                    href: _ctx.facebookHandle,
                    target: "_blank",
                    innerHTML: _ctx.FacebookIcon
                  }, null, 8, _hoisted_11)
                ]))
              : _createCommentVNode("", true),
            (_ctx.linkedInHandle)
              ? (_openBlock(), _createElementBlock("li", _hoisted_12, [
                  _createElementVNode("a", {
                    href: _ctx.linkedInHandle,
                    target: "_blank",
                    innerHTML: _ctx.LinkedInIcon
                  }, null, 8, _hoisted_13)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("h4", _hoisted_15, _toDisplayString(_ctx.$t("heuver-albourgh.components.contactForm.title")), 1),
          _createVNode(_component_FormKit, {
            id: "formkit-form",
            config: {classes: {
                    outer: '$reset formkit__outer',
                    inner: '$reset formkit__inner',
                    wrapper: '$reset formkit__wrapper',
                    label: '$reset formkit__label',
                    input: '$reset formkit__input',
                    messages: '$reset formkit__messages',
                    message: '$reset formkit__message'
                }},
            "form-class": "contact-form__form",
            type: "form",
            actions: false,
            onSubmit: _ctx.submitForm,
            "incomplete-message": false
          }, {
            default: _withCtx(() => [
              _createVNode(_component_FormKit, {
                "outer-class": "contact-form__input-text no-validation",
                type: "text",
                name: "companyName",
                label: _ctx.$t('heuver-albourgh.components.contactForm.label.companyName')
              }, null, 8, ["label"]),
              _createVNode(_component_FormKit, {
                "outer-class": "contact-form__input-text half-width",
                type: "text",
                name: "firstName",
                label: _ctx.$t('heuver-albourgh.components.contactForm.label.firstName'),
                validation: "required",
                "validation-messages": {required: _ctx.$t('heuver-albourgh.components.contactForm.label.errorMissingField')}
              }, null, 8, ["label", "validation-messages"]),
              _createVNode(_component_FormKit, {
                "outer-class": "contact-form__input-text half-width",
                type: "text",
                name: "lastName",
                label: _ctx.$t('heuver-albourgh.components.contactForm.label.lastName'),
                validation: "required",
                "validation-messages": {required: _ctx.$t('heuver-albourgh.components.contactForm.label.errorMissingField')}
              }, null, 8, ["label", "validation-messages"]),
              _createVNode(_component_FormKit, {
                "outer-class": "contact-form__input-text half-width",
                type: "text",
                name: "phoneNumber",
                label: _ctx.$t('heuver-albourgh.components.contactForm.label.phoneNumber'),
                validation: "validatePhoneNumber",
                "validation-rules": {validatePhoneNumber: _ctx.validatePhoneNumber},
                "validation-messages": {validatePhoneNumber: _ctx.$t('heuver-albourgh.components.contactForm.label.phoneNumberError')}
              }, null, 8, ["label", "validation-rules", "validation-messages"]),
              _createVNode(_component_FormKit, {
                "outer-class": "contact-form__input-text half-width",
                type: "text",
                name: "emailAddress",
                label: _ctx.$t('heuver-albourgh.components.contactForm.label.emailAddress'),
                validation: "required|email",
                "validation-messages": {required: _ctx.$t('heuver-albourgh.components.contactForm.label.errorMissingField'), email: _ctx.$t('heuver-albourgh.components.contactForm.label.emailAddressError')}
              }, null, 8, ["label", "validation-messages"]),
              _createVNode(_component_FormKit, {
                "outer-class": "contact-form__input-textarea",
                type: "textarea",
                name: "message",
                label: _ctx.$t('heuver-albourgh.components.contactForm.label.message'),
                validation: "required",
                rows: "5",
                "validation-messages": {required: _ctx.$t('heuver-albourgh.components.contactForm.label.errorMissingField')}
              }, null, 8, ["label", "validation-messages"]),
              _createVNode(_component_FormKit, {
                type: "hidden",
                name: "siteName",
                value: _ctx.siteName
              }, null, 8, ["value"]),
              _createVNode(_component_FormKit, {
                type: "text",
                name: "hp"
              }),
              _createVNode(_component_FormKit, {
                type: "text",
                name: "le"
              }),
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_component_FormKit, {
                  "outer-class": "$reset contact-form__input-checkbox formkit__outer",
                  type: "checkbox",
                  name: "termsAndConditions",
                  validation: "accepted",
                  "validation-messages": {accepted: _ctx.$t('heuver-albourgh.components.contactForm.label.errorMissingField')}
                }, null, 8, ["validation-messages"]),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('heuver-albourgh.components.contactForm.label.termsIAgree')) + " ", 1),
                _createElementVNode("a", {
                  href: _ctx.contactFormTermsConditionsLink,
                  target: _ctx.contactFormTermsConditionsLinkTarget,
                  class: "terms"
                }, _toDisplayString(_ctx.$t('heuver-albourgh.components.contactForm.label.termsLinkText')), 9, _hoisted_17)
              ]),
              _createElementVNode("button", _hoisted_18, [
                _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t('heuver-albourgh.components.contactForm.label.submitButton')), 1),
                _createElementVNode("span", {
                  class: "segmented-button__icon",
                  innerHTML: _ctx.ChevronRight
                }, null, 8, _hoisted_20)
              ], 512)
            ]),
            _: 1
          }, 8, ["onSubmit"])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["contact-popup__successful-submission", {active: _ctx.successfulSubmit}])
        }, [
          _createElementVNode("img", {
            src: _ctx.contactCompletedImage,
            class: "contact-popup__successful-submission-background",
            loading: "lazy"
          }, null, 8, _hoisted_21),
          _createElementVNode("h4", _hoisted_22, _toDisplayString(_ctx.$t('heuver-albourgh.components.contactForm.submissionComplete.text')), 1),
          _createElementVNode("p", _hoisted_23, _toDisplayString(_ctx.$t('heuver-albourgh.components.contactForm.submissionComplete.description')), 1),
          _createElementVNode("button", {
            class: "contact-popup__successful-submission-button segmented-button segmented-button--full segmented-button--green",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.finishSubmission && _ctx.finishSubmission(...args)))
          }, [
            _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.$t('heuver-albourgh.components.contactForm.submissionComplete.label.closeButton')), 1),
            _createElementVNode("span", {
              class: "segmented-button__icon",
              innerHTML: _ctx.ChevronRight
            }, null, 8, _hoisted_25)
          ])
        ], 2)
      ]),
      _: 1
    }, 512),
    _renderSlot(_ctx.$slots, "default")
  ], 64))
}